// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v5.0.1-rc.2-3-g7421590a",
    "hash": "g7421590a",
    "distance": 3,
    "tag": "v5.0.1-rc.2",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v5.0.1-rc.2",
        "major": 5,
        "minor": 0,
        "patch": 1,
        "prerelease": [
            "rc",
            2
        ],
        "build": [],
        "version": "5.0.1-rc.2"
    },
    "suffix": "3-g7421590a",
    "semverString": "5.0.1-rc.2+3.g7421590a",
    "version": "5.0.1"
};
/* tslint:enable */
